export default "__VITE_ASSET__ef22cd6e__"